<template>
    <div class="col-md-12 px-0 py-0">
        <form
            action=""
            method="post"
            enctype="multipart/form-data"
            class="form-horizontal"
        >
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Nombre</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="name"
                        class="form-control"
                        placeholder="nombre"
                    />
                    <span v-if="allerrors.name" :class="['show-error']">{{
                        allerrors.name[0]
                    }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Version</label
                >
                <div class="col-md-9">
                    <input
                        type="number"
                        v-model="version"
                        class="form-control"
                        placeholder="version"
                    />
                    <span v-if="allerrors.version" :class="['show-error']">{{
                        allerrors.version[0]
                    }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Paises</label
                >
                <div class="col-md-9">
                    <multiselect
                        v-model="countries"
                        placeholder="Seleccione paises"
                        label="name"
                        track-by="id"
                        :options="arrayCountries"
                        :multiple="true"
                        :taggable="true"
                    ></multiselect>
                    <span v-if="allerrors.countries" :class="['show-error']">{{
                        allerrors.countries[0]
                    }}</span>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Categorias</label
                >
                <div class="col-md-9">
                    <multiselect
                        v-model="categories"
                        placeholder="Seleccione categorias"
                        label="name"
                        track-by="id"
                        :options="arrayCategories"
                        :multiple="true"
                        :taggable="true"
                    ></multiselect>
                    <span v-if="allerrors.categories" :class="['show-error']">{{
                        allerrors.categories[0]
                    }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label
                    class="col-md-3 form-control-label"
                    for="text-input"
                ></label>
                <div class="col-md-9">
                    <div id="fine-uploader-manual-trigger"></div>
                    <span v-if="allerrors.image" :class="['show-error']">{{
                        allerrors.image[0]
                    }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Alt image</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="text_image_alt"
                        class="form-control"
                        placeholder="Alt image"
                    />
                    <span
                        v-if="allerrors.text_image_alt"
                        :class="['show-error']"
                        >{{ allerrors.text_image_alt[0] }}</span
                    >
                </div>
            </div>
            <div class="form-group row">
                <label
                    class="col-md-3 form-control-label"
                    for="text-input"
                >PDF bases concurso</label>
                <div class="col-md-9">
                    <div id="fine-uploader-manual-trigger-pdf"></div>
                    <span v-if="allerrors.base_pdf" :class="['show-error']">{{
                        allerrors.base_pdf[0]
                    }}</span>
                </div>
            </div>

            <div class="modal-footer">
                <button
                    type="button"
                    @click="cancelCreate()"
                    class="btn btn-secondary"
                >
                    Cancelar
                </button>
                <button type="button" @click="create()" class="btn btn-primary">
                    Crear concurso
                </button>
            </div>
        </form>
        <template-uploader></template-uploader>
        <template-uploader
            template_id="qq-template-manual-trigger-pdf"
            text_button="Pdf"
        ></template-uploader>
    </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { _ } from "vue-underscore";
import qq from "fine-uploader";
import "fine-uploader/fine-uploader/fine-uploader-new.min.css";
export default {
    data() {
        return {
            name: null,
            announcement: null,
            summary: null,
            version: null,
            image: null,
            text_image_alt: null,
            base_pdf: "",
            countries: [],
            arrayCountries: [],
            categories: [],
            arrayCategories: [],
            arrayContestAnts: [],
            allerrors: {
                name: null,
                image: null,
                text_image_alt: null,
                base_pdf: null,
            },
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [
                    "bold",
                    "italic",
                    "underline",
                    "link",
                    "bulletedList",
                    "numberedList",
                ],
            },
        };
    },
    methods: {
        getListCountries() {
            let me = this;
            axios
                .get("/api/contests/countries")
                .then(function (response) {
                    me.arrayCountries = response.data;
                })
                .catch(function (error) {});
        },
        getListCategories() {
            let me = this;
            axios
                .get("/api/categories/order")
                .then(function (response) {
                    me.arrayCategories = response.data;
                })
                .catch(function (error) {});
        },
        cancelCreate() {
            this.$emit("change");
        },
        create() {
            let me = this;
            if (me.validForm()) {
                axios
                    .post("/api/contests", {
                        name: me.name,
                        summary: me.summary,
                        announcement: me.announcement,
                        countries: _.pluck(me.countries, "id"),
                        categories: _.pluck(me.categories, "id"),
                        image: me.image,
                        version: me.version,
                        base_pdf: me.base_pdf,
                        text_image_alt: me.text_image_alt,
                    })
                    .then(function (response) {
                        me.showActionSuccess("Creacion exitosa!");
                        me.$emit("change");
                    })
                    .catch(function (error) {
                        me.showActionError(
                            JSON.stringify(error.response.data.messages)
                        );
                        me.allerrors = error.response.data.errors;
                    });
            }
        },
        validForm() {
            let me = this;
            let valid = true;

            if (!me.name) {
                me.allerrors.name = ["El campo nombre es obligatorio."];
                valid = false;
            } else if (me.name.length > 50) {
                me.allerrors.name = [
                    "El campo nombre debe tener máximo 50 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.name = null;
            }
            if (!me.version) {
                me.allerrors.version = ["El campo version es obligatorio."];
                valid = false;
            }
            if (!me.image) {
                me.allerrors.image = ["El campo imagen es obligatorio."];
                valid = false;
            }

            if (me.text_image_alt && me.text_image_alt.length > 190) {
                me.allerrors.text_image_alt = [
                    "El campo image alt debe tener máximo 190 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.text_image_alt = null;
            }

            return valid;
        },
        getUploadImageUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/upload-image`;
        },
        getUploadPdf() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/upload-file`;
        },
        getDeleteFileUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/delete-file`;
        },
        showActionSuccess(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: message,
            });
        },
        showActionError(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "error",
                position: "top-end",
                showConfirmButton: false,
                timer: 10000,
            });

            Toast.fire({
                type: "error",
                title: message,
            });
        },
    },
    mounted() {
        this.getListCountries();
        this.getListCategories();
        let me = this;
        new qq.FineUploader({
            element: document.getElementById("fine-uploader-manual-trigger"),
            request: {
                endpoint: this.getUploadImageUrl(),
            },
            deleteFile: {
                enabled: true, // defaults to false
                endpoint: this.getDeleteFileUrl(),
            },
            template: "qq-template-manual-trigger",
            validation: {
                allowedExtensions: ["jpeg", "jpg", "png", "svg"],
                sizeLimit: 20971520,
                image: {
                    maxHeight: 430,
                    minHeight: 430,
                    maxWidth: 1440,
                    minWidth: 1440,
                },
            },
            messages: {
                noFilesError: "Seleccione una imagen.",
                maxWidthImageError:
                    "Dimensiones incorrectas debe ser de 1440x430 px.",
                minWidthImageError:
                    "Dimensiones incorrectas debe ser de 1440x430 px.",
                maxHeightImageError:
                    "Dimensiones incorrectas debe ser de 1440x430 px.",
                minHeightImageError:
                    "Dimensiones incorrectas debe ser de 1440x430 px.",
            },
            callbacks: {
                onComplete: function (id, name, response) {
                    if (response.success) {
                        me.allerrors["image"] = null;
                        me.image = response.path;
                    } else {
                        me.allerrors["image"] = ["Error en la imagen"];
                    }
                },
                onDeleteComplete: function (id, name, response) {
                    me.allerrors["image"] = null;
                    me.image = "";
                },
            },
            multiple: false,
        });

        new qq.FineUploader({
            element: document.getElementById(
                "fine-uploader-manual-trigger-pdf"
            ),
            request: {
                endpoint: this.getUploadPdf(),
            },
            deleteFile: {
                enabled: true, // defaults to false
                endpoint: this.getDeleteFileUrl(),
            },
            template: "qq-template-manual-trigger-pdf",
            validation: {
                allowedExtensions: ["pdf"],
                sizeLimit: 20971520,
            },
            messages: {
                noFilesError: "Seleccione un pdf.",
            },
            callbacks: {
                onComplete: function (id, name, response) {
                    if (response.success) {
                        me.allerrors["base_pdf"] = null;
                        me.base_pdf = response.path;
                    } else {
                        me.allerrors["base_pdf"] = ["Error en el pdf."];
                    }
                },
                onDeleteComplete: function (id, name, response) {
                    me.allerrors["base_pdf"] = null;
                    me.base_pdf = "";
                },
            },
            multiple: false,
        });
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
</style>
